import * as React from "react";
import { CSSProperties } from "@material-ui/core/styles/withStyles";

// constants
import { Slot } from "@clockwise/client-commons/src/constants/time-slot";

// util
import { getSlotIndex } from "@clockwise/client-commons/src/util/time-slot";

// styles
import { colors } from "@styles/color.styles";

export interface WorkingHoursRendererState {
  minStart: number;
  maxEnd: number;
}

export interface IWorkingHoursDaySetting {
  setting: {
    minSlot: Slot;
    maxSlot: Slot;
  };
}

const workingHours: CSSProperties = {
  position: "absolute",
  background: `repeating-linear-gradient(-45deg, #ffffff, #ffffff 5px, #F7F7F7 5px, #F7F7F7 10px)`,
  width: "100%",
};

export const workingHoursStyles = {
  workingHours,
};

/**
 * A factory method that returns an instance method to be bound to a component.
 * Component props must extend WorkingHoursRendererProps and state must extend WorkingHoursRendererState.
 *
 * @param showBorder whether or not to show the border of the working hours
 */
export const renderWorkingHoursFactory = (showBorder?: boolean, className = "workingHours") =>
  function renderWorkingHours(
    this: React.Component<any, WorkingHoursRendererState>,
    displayData?: IWorkingHoursDaySetting,
  ) {
    const { minStart, maxEnd } = this.state;
    const { classes } = this.props;

    if (!displayData || displayData.setting.minSlot === displayData.setting.maxSlot) {
      return (
        <div
          className={classes[className]}
          style={{
            top: "0%",
            bottom: "0%",
          }}
        />
      );
    }

    return (
      <React.Fragment>
        <div
          className={classes[className]}
          style={{
            top: `0%`,
            height: `calc(${Math.min(
              ((getSlotIndex(displayData.setting.minSlot) - minStart) / (maxEnd - minStart)) * 100,
              100,
            )}% + 2px)`,
            borderBottom: showBorder ? `3px dotted ${colors.yellow.standard}` : "none",
          }}
        />
        <div
          className={classes[className]}
          style={{
            top: `calc(${Math.max(
              ((getSlotIndex(displayData.setting.maxSlot) + 1 - minStart) / (maxEnd - minStart)) *
                100,
              0,
            )}%)`,
            bottom: `0%`,
            borderTop: showBorder ? `3px dotted ${colors.blueDusk.lighter}` : "none",
          }}
        />
      </React.Fragment>
    );
  };
